import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { useFetch } from '../../hooks/useFetch';
import { useEffect, useState } from 'react';
import {
  Container,
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Divider,
  Card,
  Paper,
  CardActions,
  CardContent,
} from '@mui/material/';
import format from 'date-fns/format';
import CircularProgress from '@mui/material/CircularProgress';
import SelectedStudent from '../SelectedStudent';
import ConsultQuoteTotal from './ConsultQuoteTotal';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import SelectedVenue from '../SelectedVenue';
import CloseIcon from '@mui/icons-material/Close';
import { DataGrid } from '@mui/x-data-grid';

function ViewConsultQuote({
  studentId,
  consultId,
  setViewOrder,
  setViewQuote,
}) {
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const [tableData, setTableData] = useState([]);

  const {
    postData,
    error,
    isPending,
    data: quoteData,
  } = useFetch('https://pcapi.bi-oss.co.za/consultations/generatequote');

  useEffect(() => {
    if (studentId && consultId) {
      postData({
        studentId,
        consultId,
      });
    }
  }, [studentId, consultId]);

  useEffect(() => {
    if (quoteData) {
      setTableData(quoteData);
    }
  }, [quoteData]);

  const columns = [
    {
      field: 'availableDate',
      headerName: 'Date:',
      width: 100,
      valueFormatter: (params) => {
        return format(new Date(params.value), 'yyyy/MM/dd');
      },
    },

    { field: 'Weekday', headerName: 'Day:', width: 100, editable: false },
    { field: 'startTime', headerName: 'Start Time', width: 100 },
    { field: 'endTime', headerName: 'End Time', width: 100 },

    {
      field: 'candidate',
      headerName: 'Candidate:',
      width: 270,
      editable: false,
    },
    { field: 'total', headerName: 'Fee:', width: 150, editable: false },
  ];

  const handleOnCellClick = (e) => {
    // window.open(e.row.fileURL, '_blank')
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setViewOrder(1);
  };

  return (
    <>
      {isPending && (
        <Container maxWidth="md">
          <Box mb={5} />

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
            sx={{
              border: 'solid',
              borderWidth: '3px',
              borderColor: 'primary.main',
              borderRadius: 2,
            }}
          >
            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
                <Typography variant="h6" component="h3" color="primary.main">
                  Generating quotation ........
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      )}

      {!isPending && (
        <Container maxWidth="md">
          <Box mb={5} />

          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
            sx={{
              border: 'solid',
              borderWidth: '3px',
              borderColor: 'primary.main',
              borderRadius: 2,
            }}
          >
            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography
                  variant="h4"
                  component="h4"
                  color="primary.main"
                  sx={{ textAlign: 'center' }}
                >
                  Academic Consultation Quote
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography variant="h5" component="h5" color="primary">
                  Consultation Details:
                </Typography>
              </Box>
            </Grid>

            {!isPending && !error && tableData && tableData.length > 0 && (
              <>
                <Grid item xs={12} minWidth={0}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <DataGrid
                      rows={tableData}
                      columns={columns}
                      sx={{
                        color: 'primary.main',
                        borderColor: 'primary.main',
                        borderWidth: 3,
                        fontWeight: 'bold',
                        m: 1,
                        align: 'center',
                        headerAlign: 'center',
                        autoCapitalize: 'words',
                      }}
                      disableRowSelectionOnClick={true}
                      disableColumnSelector={true}
                      hideFooterRowCount
                      hideFooterSelectedRowCount
                      hideFooterPagination
                      getRowId={(row) => row.id}
                      autoHeight
                      pageSize={(row) => row.length}
                      components={{
                        Footer: () => <ConsultQuoteTotal />,
                      }}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Typography variant="body2" component="p" color="primary">
                      Consultations will only be scheduled once online payment
                      is complete.
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Typography variant="body2" component="p" color="primary">
                      Once you are ready to process your consultation payment
                      online, click on CheckOut and follow the online payment
                      instructions.
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Button
                          fullWidth
                          variant="contained"
                          onClick={handleSubmit}
                        >
                          Checkout
                          <ShoppingCartCheckoutIcon />
                        </Button>
                      </Box>

                      <Box mb={5} />
                    </Grid>
                  </Box>

                  <Box mb={5} />
                </Grid>
              </>
            )}

            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography variant="body2" component="p" color="primary">
                  If you would like to cancel your consultation or process
                  later, click the cancel button.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  maxWidth: '95%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={(e) => setViewQuote(0)}
                    >
                      <CloseIcon /> Cancel
                    </Button>
                  </Box>

                  <Box mb={5} />
                </Grid>
              </Box>

              <Box mb={5} />
            </Grid>
          </Grid>
        </Container>
      )}
    </>
  );
}

export default ViewConsultQuote;
